var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"trading-button",class:_vm.buttonClass},[_c('span',{staticClass:"state-layer"},[_c('span',{staticClass:"label__largetrading"},[_vm._v(_vm._s(_vm.buttonText))]),_c('span',{staticClass:"price label__largetrading"},[_vm._t("sum")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }